import { Container, withStyles } from '@material-ui/core';
const Page = withStyles((theme) => ({
    '@global': {
        '*': {
            boxSizing: 'border-box',
        },
        body: {
            margin: 0,
            backgroundColor: theme.palette.primary.contrastText,
            minHeight: '100vh',
            [theme.breakpoints.down('sm')]: {
                backgroundColor: theme.palette.common.white,
            },
        },
    },
    root: {
        position: 'relative',
        width: '100vw',
        maxWidth: '100%',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
}), { name: 'Page' })(Container);
export default Page;
